var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('b-sidebar', {
    attrs: {
      "id": "sidebar-tranferencia-fields",
      "backdrop-variant": "dark",
      "backdrop": "",
      "right": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function fn(_ref) {
        var hide = _ref.hide;
        return [_c('div', {
          staticClass: "d-flex text-light align-items-center px-3 py-2"
        }, [_c('button', {
          ref: "salvarTranferencia",
          staticClass: "btn btn-primary btn-hover-dark font-weight-bold",
          staticStyle: {
            "width": "100%"
          },
          on: {
            "click": _vm.salvarTransferencia
          }
        }, [_vm._v(" Realizar transferência ")])])];
      }
    }])
  }, [_c('div', {
    staticClass: "px-2 py-2"
  }, [_c('div', {
    staticClass: "p-2",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h4', {
    staticClass: "text-dark"
  }, [_vm._v("Transferência entre contas")]), _c('p', [_vm._v("A transferência será realizada somente utilizando o saldo.")]), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "banco",
      "label-for": "banco",
      "label": "Conta Origem:"
    }
  }, [_c('strong', [_vm._v("Movimento do Caixa")])])], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "banco",
      "label-for": "banco",
      "label": "Conta Destino:"
    }
  }, [_c('b-form-select', {
    model: {
      value: _vm.transferencia.banco,
      callback: function callback($$v) {
        _vm.$set(_vm.transferencia, "banco", $$v);
      },
      expression: "transferencia.banco"
    }
  }, _vm._l(_vm.bancos, function (b) {
    return _c('b-form-select-option', {
      key: b.id_banco + 'bancos',
      attrs: {
        "value": b
      }
    }, [_vm._v(" " + _vm._s(b.nome) + " ")]);
  }), 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_transferencia",
      "label-for": "data_transferencia",
      "label": "Data Transferência:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "id": "data_transferencia",
      "placeholder": " ",
      "locale": "pt-br"
    },
    model: {
      value: _vm.transferencia.data_transferencia,
      callback: function callback($$v) {
        _vm.$set(_vm.transferencia, "data_transferencia", $$v);
      },
      expression: "transferencia.data_transferencia"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "valor",
      "label-for": "valor",
      "label": "Valor R$:"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.transferencia.valor_tranferencia,
      callback: function callback($$v) {
        _vm.$set(_vm.transferencia, "valor_tranferencia", $$v);
      },
      expression: "transferencia.valor_tranferencia"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1)], 1)])]), _c('FilterFields', {
    attrs: {
      "fields": [{
        type: 'text',
        label: 'Descrição',
        field: 'descricao'
      }, {
        type: 'select',
        label: 'Tipo',
        field: 'tipo',
        options: ['Receita', 'Despesa', 'Todos']
      }, {
        type: 'date',
        label: 'Data(s) de movimento(s)',
        field: 'data'
      }, {
        type: 'text',
        label: 'Plano de Contas',
        field: 'plano_contas'
      }, {
        type: 'text',
        label: 'Centro de custo',
        field: 'centro_custo'
      }]
    }
  }), _c('div', {
    staticClass: "d-flex align-items-center my-2 display: flex;"
  }, [_c('div', {
    staticClass: "period-filter"
  }, [_c('span', {
    staticClass: "btn btn-secondary period-filter__label"
  }, [_vm._v(_vm._s(_vm.periodFilterLabel))]), _c('b-dropdown', {
    staticClass: "period-filter__dropdown",
    attrs: {
      "id": "menu",
      "variant": "primary",
      "toggle-class": "period-filter__toggle"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('span', {
          staticClass: "sr-only"
        }, [_vm._v("Selecionar período")])];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', {
    attrs: {
      "active": _vm.hasPeriodFilter && _vm.filtersStore.filterOptionSelected.id === 1
    },
    on: {
      "click": function click() {
        return _vm.filtersStore.filterOptionSelected = {
          id: 1,
          label: 'Hoje'
        };
      }
    }
  }, [_vm._v("Hoje")]), _c('b-dropdown-item', {
    attrs: {
      "active": _vm.hasPeriodFilter && _vm.filtersStore.filterOptionSelected.id === 2
    },
    on: {
      "click": function click() {
        return _vm.filtersStore.filterOptionSelected = {
          id: 2,
          label: 'Ontem'
        };
      }
    }
  }, [_vm._v(" Ontem ")]), _c('b-dropdown-item', {
    attrs: {
      "active": _vm.hasPeriodFilter && _vm.filtersStore.filterOptionSelected.id === 3
    },
    on: {
      "click": function click() {
        return _vm.filtersStore.filterOptionSelected = {
          id: 3,
          label: 'Essa semana'
        };
      }
    }
  }, [_vm._v(" Essa semana ")]), _c('b-dropdown-item', {
    attrs: {
      "active": _vm.hasPeriodFilter && _vm.filtersStore.filterOptionSelected.id === 4
    },
    on: {
      "click": function click() {
        return _vm.filtersStore.filterOptionSelected = {
          id: 4,
          label: 'Semana passada'
        };
      }
    }
  }, [_vm._v(" Semana passada ")]), _c('b-dropdown-item', {
    attrs: {
      "active": _vm.hasPeriodFilter && _vm.filtersStore.filterOptionSelected.id === 5
    },
    on: {
      "click": function click() {
        return _vm.filtersStore.filterOptionSelected = {
          id: 5,
          label: 'Esse mês'
        };
      }
    }
  }, [_vm._v(" Esse mês ")])], 1)], 1), _c('b-col', [_c('Chart', {
    attrs: {
      "endpoint": "/financeiro/total",
      "modulo": "financeiro"
    }
  })], 1)], 1), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.sidebar-tranferencia-fields",
      modifiers: {
        "sidebar-tranferencia-fields": true
      }
    }, {
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Tranferência entre contas',
      expression: "'Tranferência entre contas'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    staticClass: "border border-muted",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0",
      "z-index": "99"
    },
    attrs: {
      "variant": "secondary"
    }
  }, [_c('Transfer', {
    attrs: {
      "size": 20
    }
  })], 1)], 1), _c('TableApp', {
    ref: "financeiro",
    attrs: {
      "titulo": "Movimento do Caixa",
      "acaoBtn": "/#/financeiro/novo",
      "textoBtn": "Novo Movimento",
      "api-url": "/financeiro",
      "fields": _vm.fields,
      "classFilterColumn": "descricao",
      "perPage": 10
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'data' ? _c('span', {
          attrs: {
            "slot": "data"
          },
          slot: "data"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.formatDate(props.rowData.data)) + " ")])]) : _vm._e(), props.field == 'descricao' ? _c('span', {
          attrs: {
            "slot": "descricao"
          },
          slot: "descricao"
        }, [_c('span', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', [_c('a', {
          staticClass: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
        }, [_vm._v(_vm._s(props.rowData.descricao))]), _c('div', {
          staticClass: "d-flex align-items-center flex-wrap"
        }, [_c('span', {
          staticClass: "text-muted font-weight-bold"
        }, [_vm._v(" " + _vm._s(props.rowData.plano_conta) + " ")]), props.rowData.centro_custo ? _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: 'Centro de custo',
            expression: "'Centro de custo'",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "badge badge-light-primary d-inline-flex align-items-center ml-2"
        }, [_c('TagOutline', {
          staticClass: "mr-1",
          attrs: {
            "size": 13
          }
        }), _vm._v(" " + _vm._s(props.rowData.centro_custo) + " ")], 1) : _vm._e()])])])])]) : _vm._e(), props.field == 'valor' ? _c('span', {
          attrs: {
            "slot": "valor"
          },
          slot: "valor"
        }, [_c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg"
        }, [_vm._v("R$ " + _vm._s(props.rowData.tipo == "E" ? _vm.numberToReal(props.rowData.valor, 2) : "-" + _vm.numberToReal(props.rowData.valor, 2)) + " ")]), _c('span', {
          class: props.rowData.tipo == 'E' ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'
        }, [_vm._v(" " + _vm._s(props.rowData.tipo == "E" ? "Receita" : "Despesa") + " ")])]) : _vm._e(), props.field == 'meiopagamento' ? _c('span', {
          attrs: {
            "slot": "meiopagamento"
          },
          slot: "meiopagamento"
        }, [props.rowData.meio_pagamento ? _c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.meio_pagamento.descricao) + " ")]) : _c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v("-")])]) : _vm._e(), props.field == 'plano_contas' ? _c('span', {
          attrs: {
            "slot": "plano_contas"
          },
          slot: "plano_contas"
        }, [props.rowData.plano_contas ? _c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.plano_contas.descricao) + " ")]) : _c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v("-")])]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "130px"
          }
        }, [_c('div', {
          staticClass: "dropdown dropdown-inline"
        }, [_c('router-link', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Editar',
            expression: "'Editar'"
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          attrs: {
            "to": {
              name: 'financeiroEditar',
              params: {
                id: props.rowData.id
              }
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 16,
            "title": "Editar"
          }
        })], 1), props.rowData.id_empresa ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Excluir',
            expression: "'Excluir'"
          }],
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.excluir(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1) : _vm._e()], 1)])])]) : _vm._e()];
      }
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };